import React from "react";

interface TagsSectionProps {
  subject: string;
  city: string;
  state: string;
}

const TagsSection: React.FC<TagsSectionProps> = ({ subject, city, state }) => {
  return (
    <div className="flex flex-wrap gap-2 mt-8 mb-4">
      <span className="text-sm text-white/70 mr-2">Topics:</span>
      <span className="px-3 py-1 bg-cannabis-green-900/80 text-cannabis-green-200 text-xs rounded-full font-medium">
        {subject}
      </span>
      <span className="px-3 py-1 bg-legal-blue-900/80 text-malibu-blue-200 text-xs rounded-full font-medium">
        {city}
      </span>
      <span className="px-3 py-1 bg-justice-gold-900/80 text-justice-gold-200 text-xs rounded-full font-medium">
        {state}
      </span>
    </div>
  );
};

export default TagsSection;
